export const FETCHING_SELFCARE_FILES = "FETCHING_SELFCARE_FILES";
export const UPDATING_OPERATOR = "UPDATING_OPERATOR";